import { Text } from '@/components/ui/text';
import { UserAvatar } from '@/components/ui/user-avatar';
import React from 'react';
import { View } from 'react-native';

interface AvatarGroupUser {
  id: string;
  avatarUrl?: string | null;
  name?: string | null;
}

interface AvatarGroupProps {
  users: AvatarGroupUser[];
  totalCount: number;
  size?: number;
  overlapPx?: number;
  maxVisible?: number;
}

/**
 * Overlapping row of small avatars plus a "+N" overflow count. The avatars are
 * decorative: the surrounding control carries the label (e.g. "3 likes").
 */
export function AvatarGroup({
  users,
  totalCount,
  size = 22,
  overlapPx = 8,
  maxVisible = 3,
}: AvatarGroupProps) {
  const visible = users.slice(0, maxVisible);
  const overflow = totalCount - visible.length;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {visible.map((user, index) => (
        <UserAvatar
          key={user.id}
          uri={user.avatarUrl}
          name={user.name}
          size={size}
          decorative
          className="border-border-visible"
          style={{
            marginLeft: index === 0 ? 0 : -overlapPx,
            zIndex: visible.length - index,
            borderWidth: 0.5,
          }}
        />
      ))}
      {overflow > 0 && (
        <Text
          className="text-muted-foreground"
          style={{ fontSize: 12, marginLeft: 4 }}
        >
          +{overflow}
        </Text>
      )}
    </View>
  );
}
